/*@flow*/
import nested from 'lib/nested';
import isNil from 'lib/t/isNil';
import humanize from 'underscore.string/humanize';
import type { TypeInfo, SelectOption } from '../types';

export const SOURCE = 'tcomb-form';

export function move(arr0: any[], fromIndex: number, toIndex: number): Array<any> {
  const arr = [...arr0];
  const element = arr.splice(fromIndex, 1)[0];
  arr.splice(toIndex, 0, element);
  return arr;
}

export function getDefaultLabel(key: ?(string | number)): any | string {
  if (isNil(key)) return '';
  return humanize(key);
}

export function getPlaceholder(
  options: $Shape<{ attrs?: { placeholder?: string } }>
): void | string {
  const attrs = options.attrs || {};
  return attrs.placeholder;
}

export function getNullOption(options: $Shape<{ nullOption?: SelectOption }>): SelectOption | {|text: string, value: string|} {
  return Object.prototype.hasOwnProperty.call(options, 'nullOption') &&
    typeof options.nullOption === 'object'
    ? options.nullOption
    : { value: '', text: '-' };
}

export function isInnerTypeList(typeInfo: TypeInfo): boolean {
  return nested<?string>(typeInfo, 'innerType.meta.kind') === 'list';
}
